import { useContext } from 'react'

import SettingsContext from '../contexts/SettingsContext'

export default function useSettings() {
  const context = useContext(SettingsContext)

  if (context === undefined) {
    throw new Error('useSettings() must be called inside SettingsProvider')
  }

  return context
}
